import { ACCOUNT_ROUTES, redirectToAccount } from '@/infra/Account/accountUrl'
import { removeAuthCookie } from '@/infra/http/authCookie'

export interface BootstrapError {
  code: string
  title: string
  message: string
  type: 'action' | 'killScreen'
  action: () => void
}

/**
 * Leva ao login do Account com a URL que o usuário tentou acessar no `redirect`. Depois do login, o
 * Account grava o `_nat` e devolve o usuário para essa mesma URL, onde o boot lê o cookie normalmente.
 */
function redirectToAccountLogin(): void {
  redirectToAccount(ACCOUNT_ROUTES.login)
}

export const BootstrapErrorDefault: BootstrapError = {
  code: 'DEFAULT',
  title: 'Erro',
  message: 'Ocorreu um erro inesperado. Tente novamente mais tarde',
  type: 'killScreen',
  action: () => {}
}

export const BootstrapErrors: BootstrapError[] = [
  {
    code: 'NO_INTERNET_CONNECTION',
    title: 'Sem conexão com a internet',
    message: 'Verifique sua conexão e tente novamente',
    type: 'killScreen',
    action: () => {}
  },
  {
    code: 'AUTHENTICATION_COOKIE_NOT_FOUND',
    title: 'Sessão expirada!',
    message: 'Por favor, faça login novamente',
    type: 'action',
    action: redirectToAccountLogin
  },
  {
    code: 'SUBSCRIPTION_NOT_OK',
    title: 'Há um problema com a sua assinatura!',
    message: 'Estamos te redirecionando para solucionar o problema',
    type: 'action',
    // Sem a capability `product:planningapp`: a assinatura é feita no Account, cujo botão "Voltar para o
    // app" usa o `redirect` para devolver o usuário para a URL que ele tentou acessar.
    action: () => redirectToAccount(ACCOUNT_ROUTES.subscription)
  },
  {
    code: 'ACCOUNT_UNAVAILABLE',
    title: 'Instabilidade temporária',
    message:
      'Estamos com uma instabilidade temporária. Nosso time já está trabalhando para resolver o problema. Tente novamente em poucos minutos.',
    type: 'killScreen',
    action: () => {}
  },
  {
    code: 'ACCOUNT_TOKEN_ERROR',
    title: 'Sessão expirada!',
    message: 'Por favor, faça login novamente',
    type: 'action',
    action: () => {
      // A API rejeitou o token. Sem apagar o cookie, a volta do login reaproveitaria o mesmo token inválido.
      removeAuthCookie()
      redirectToAccountLogin()
    }
  }
]
